(() => {
  const init = scope => {
    scope.querySelectorAll('[data-concept-gallery]').forEach(root => {
      if (root.dataset.conceptReady) return;
      const buttons = [...root.querySelectorAll('[data-concept-button]')];
      const panels = [...root.querySelectorAll('[data-concept-panel]')];
      const status = root.querySelector('[data-concept-status]');
      if (!buttons.length || !panels.length) return;
      const choose = (id, announce) => {
        const selected = panels.find(panel => panel.dataset.conceptPanel === id);
        if (!selected) return;
        panels.forEach(panel => { panel.hidden = panel !== selected; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.conceptButton === id)));
        if (announce && status) status.textContent = selected.dataset.conceptTitle;
      };
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.conceptButton, true)));
      choose(buttons[0].dataset.conceptButton, false);
      root.querySelector('[data-concept-choices]').hidden = false;
      root.dataset.conceptReady = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement || document));
})();
